'use strict';

angular.module('cimerFrontEndApp').directive('institution', ['$http', 'InstitutionService', function ($http, InstitutionService) {

  return {
    retrict: 'E',
    templateUrl:'/Content/Templates/institutionTemplate.html',
    scope: {
      value: '=ngModel',
      classes: '@classes'
    },
    require:'ngModel',
    link: function(scope,elements,attrs) {
      scope.loadingInstitution=false;
      scope.noResults = false;
      scope.isSearching = false;
      scope.searchInstitutions = function (text) {
        scope.isSearching = true;
        return InstitutionService.search(text).then(function (response) {
          scope.isSearching = false;
          return response.data;
        }, function(err){
          //TODO: error handling
        });
      };
    }
};
}]);
